import styled from "styled-components";
import { colors } from "stylesheets";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  width: 100%;
  padding: 0 40px 25px;

  & > :not(:last-child) {
    margin-bottom: 15px;
  }
`;

export const Line = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  width: 100%;

  & > button {
    margin: auto 0;
  }

  & > :not(:last-child) {
    margin-right: 15px;
  }
`;

export const LoadingContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 250px;
`;
